export const TRACKING_DATA_KEY = 'frd_tracking_data';

const storeTrackerData = (key, value) => {
  try {
    let trackingData = JSON.parse(localStorage.getItem(TRACKING_DATA_KEY)) || {};

    // Skip if value hasn't changed
    if ((trackingData[key]?.value ?? null) === value) {
      return;
    }

    trackingData[key] = {
      value: value,
      timestamp: new Date().toISOString(),
    };

    localStorage.setItem(TRACKING_DATA_KEY, JSON.stringify(trackingData));
  } catch (e) {
    // console.warn('Failed to store tracking data:', e);
  }
};

const safeStoreTrackerData = (key, getter) => {
  try {
    const value = getter();
    if (value) {
      storeTrackerData(key, value);
    }
  } catch (e) {
    // console.warn(`Failed to store tracker data for ${key}:`, e);
  }
};

const storeGbraid = () => {
  const gbraid = new URLSearchParams(window.location.search).get('gbraid');
  if (gbraid) {
    storeTrackerData('gbraid', gbraid);
  }
};

const storeGclid = () => {
  safeStoreTrackerData('gclid', () => {
    const gclData = JSON.parse(localStorage.getItem('_gcl_ls'));
    return gclData?.gclid?.value?.value || null;
  });
};

const storeRtbId = () => {
  safeStoreTrackerData('rtb_lid', () => {
    const raw = localStorage.getItem('__rtbh.lid');
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    return parsed?.id || null;
  });
};

const storeMicrosoftData = () => {
  // Store UET Visitor ID
  safeStoreTrackerData('ms_uetvid', () => localStorage.getItem('_uetvid'));

  // Store UET Session ID
  safeStoreTrackerData('ms_uetsid', () => localStorage.getItem('_uetsid'));

  // Store Microsoft Click ID (from URL or localStorage fallback)
  safeStoreTrackerData('ms_msclkid', () => {
    const urlParams = new URLSearchParams(window.location.search);
    const msclkidFromUrl = urlParams.get('msclkid');

    // Fallback to localStorage if not in URL
    return msclkidFromUrl || localStorage.getItem('_uetmsclkid');
  });
};

export const isPaidTraffic = () => {
  const params = new URLSearchParams(window.location.search);
  return !!(params.get('gclid') || params.get('gbraid') || params.get('msclkid'));
};

export default function startTrackingDataStorage() {
  storeGbraid();
  storeGclid();
  storeRtbId();
  storeMicrosoftData();
}